import { AudioManager, Track } from "../../AudioManager";
import { SetStyles, Point, Size, CreateElement, LogGroup} from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { CanvasSprite, CanvasSpriteSizing } from "../Sprite/CanvasSprite";
import { ICometInterface } from "./ICometInterface";
export class CometDefault implements ICometInterface
{
    protected canvasSprite: CanvasSprite;

    
    protected topCenterOffset: number = 0.42;
    protected bottomCenterOffset: number= 0.197;
    protected rotateOrigin: string = "50% 87%";
    protected view : HTMLElement = null;
    protected audio : AudioManager = null;
    protected resid : ResourceIdentifier = null;
    protected FpsFactor: number;

    protected fps: number;
    public constructor(audio : AudioManager , resid : ResourceIdentifier, fpsFactor: number){
        this.audio = audio;       
        this.resid = resid;
        this.FpsFactor = fpsFactor;
    }
    StartSpineComet(source: Point, dest: Point, currentScatterCometIndex: number): void {
        throw new Error("Method not implemented.");
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources/cometShort", ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet"), true, LogGroup.Global.Add("BonusWinShow").Add("Commet"), true))
        this.audio.AddTrack(new Track(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources//tracks/cometShort" + Settings.audioFormat, this.resid.ScopedResourceName("comet")));
    }
    
    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.canvasSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
        this.fps =this.canvasSprite.sprite.GetFPS()
        // clear comet sprite when finished to prevent blinking
        this.canvasSprite.sprite.ResetToFirstFrame = false;
        this.canvasSprite.ClearOnIdle = true;
        this.canvasSprite.sprite.SetFPS(this.canvasSprite.sprite.GetFPS()*this.FpsFactor);
        this.canvasSprite.AddOnCompleteCallback(this.SpriteComplete.bind(this));
        
        SetStyles(this.canvasSprite.View(), {
            position: "relative"
        });

        this.canvasSprite.Hide();
        
        this.view = CreateElement("div",{
            classes : ["comet-container"],
            style:{
                //position : "abstolute",
                width : this.canvasSprite.sprite.Size().Width + "px",
                height : this.canvasSprite.sprite.Size().Width + "px",
            }
        });
        this.view.appendChild(this.canvasSprite.View());
    }

    public Start(source: Point, dest: Point)
    {
        //calculate distances between 2 points
        let distanceX: number = source.x - dest.x;
		let distanceY: number = source.y - dest.y;
		let distance: number = Math.sqrt(distanceX*distanceX + distanceY*distanceY); 

		//bigger animation
        let animDistance: number = distance + 
            distance*this.topCenterOffset + 
            distance*this.bottomCenterOffset;
        //calculeta size
		let commetToPlaySpriteSize: Size = this.canvasSprite.sprite.Size();
		let sizeFactor: number = animDistance / commetToPlaySpriteSize.Height;
        let newWidt: number = commetToPlaySpriteSize.Width * sizeFactor;
        //calculete scale
        let scaleWidth : number= newWidt / commetToPlaySpriteSize.Width;
        let scaleHeight : number = animDistance / commetToPlaySpriteSize.Height;
        //calculate angle 
        let angle: number = (Math.atan2(distanceY, distanceX) * 180 / Math.PI) - 90;

        
        //change view position and size 
        this.view.style.width = newWidt + "px";
        this.view.style.height = animDistance + "px";
        this.view.style.left = (source.x - newWidt*this.topCenterOffset)+"px";
		this.view.style.top = (source.y - animDistance + distance * this.bottomCenterOffset)+"px";        
        this.view.style.transform = "rotate(" + angle + "deg)";
        this.view.style.transformOrigin = this.rotateOrigin;
        //change canvas size whit scale
        this.canvasSprite.View().style.transformOrigin = "0% 0%";
        this.canvasSprite.View().style.transform =`scale(${scaleWidth} , ${scaleHeight})`;   
        //start anim and show 
        this.canvasSprite.Start(false);
        this.canvasSprite.Show();
    }

    public StopsCommets() {
        this.canvasSprite.Stop();
        this.canvasSprite.Hide();
    }

    public OnCompleteCallback: () => void = null;
    public SpriteComplete(): void {
        this.canvasSprite.Hide();
        this.OnCompleteCallback?.();
    }

    public View(): HTMLElement
    {
        return this.view;
    }

    public Update(): void
    {
        this.canvasSprite.Update();
    }

    public PlayCometSound(){
		this.audio.Play(this.resid.ScopedResourceName("comet"));
	}

    public StopCometSound(){
		this.audio.Stop(this.resid.ScopedResourceName("comet"));
	}

    public UpdateCometAnimation(celebrationFactor: number) {
        this.canvasSprite.sprite.SetFPS(this.canvasSprite.sprite.GetFPS()*celebrationFactor)
        
    }
}